import * as collections from './collections';
import toJS from './toJS';

export default {
	collections,
	toJS,
};
